<template>
  <div class="seu-email-input">

    <mailchimp-subscribe
      url="https://seu.us21.list-manage.com/subscribe/post-json"
      user-id="4ea7f6f2af0b649dadd05429c"
      :list-id="listId"
      @error="onError"
      @success="onSuccess"
    >
      <template v-slot="{ subscribe, setEmail, error, success, loading }">
        <div class="mailchimp-subscribe-form">
          <input type="text" :placeholder="placeholder" class="paragraph-1-large" v-model="email" @input="setEmail($event.target.value)">
          <div v-if="$v.email.$error"> {{$t('newsletter.email_required')}}</div>

          <seu-button
            :label="buttonLabel"
            :button-icon-before="arrowIcon"
            @click="submitForm(subscribe)"
          />

        </div>
      </template>
    </mailchimp-subscribe>






  </div>
</template>

<script>
  import MailchimpSubscribe from 'vue-mailchimp-subscribe'
  import SeuButton from "/seu-frontend/components/SeuButton";
  import {email, required} from "vuelidate/lib/validators"
  import {mapState} from "vuex";

  export default {
    name: 'SeuEmailInput',
    components: {SeuButton,MailchimpSubscribe},
    props: {
      placeholder: {
        type: String,
      },
      buttonLabel: {
        type: String,
      }
    },
    data: () => ({
      email: null,

      arrowIcon: require('../assets/icons/arrow-white-right.svg')
    }),
    validations: {
      email: {
        required,
        email
      },
    },
    computed:{
      ...mapState({
        currentLanguage: state => state.currentLanguage.toLowerCase(),
      }),
      listId(){
        return this.currentLanguage === 'de' ? 'f7bb1bcdea' :'8a2d32a5d5'
      }
    },
    methods: {
      submitForm(subscribeCallback) {
        this.$v.$touch()
        if (this.$v.$error) {
          return;
        } else {
          subscribeCallback()
        }
      },
      onError(er) {
        this.$bubbleUp('subscribed',false)
      },
      onSuccess(){
        this.$bubbleUp('subscribed',true)
      }

    }
  }
</script>

<style lang="scss">
  @import "SeuEmailInput.scss";
</style>
